import React from "react";

const ProjectEvaluation = () => {
  return <div className="text-text-1">ProjectEvaluation</div>;
};

export default ProjectEvaluation;
